<template>

<form  @submit.prevent="search">
    <b-input-group class="" style="max-width:260px;">
        <b-form-input placeholder="Ingresá tu cupón" class="input" v-model="searchInput" maxlength="8" ></b-form-input>
        <b-input-group-append>
            <input type="submit" class="btn btn-success btn_search" :value="!searching ? 'Buscar':'Buscando'" >
        </b-input-group-append>
        <p class="error-label" v-if="error">No se ha encontrado un cupón con el código ingresado</p>
    </b-input-group>
</form>

</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

export default {
	name: "GratiaCodeSearch",
	components:{
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
    },
	data(){
		return{
            searchInput: '',
            API_URL: process.env.VUE_APP_API_URL,
            error: false,
            searching: false
		}
    },
	methods:{
        search() {
            this.searching = true
            this.error = false
            this.$apollo.query({
                query: gql`query medicCoupon( $code: String, $status: Int ){
                    medicCoupon(code: $code, status: $status) {
                        id
                        medic{
                            id
                            slug
                        }
                        code
                    }
                }`,
                variables: {
                    status: 1,
					code: this.searchInput,
                }
            })
            .then((data) => {
                this.searching = false
                if( data.data.medicCoupon && data.data.medicCoupon.id >0 ){

                    //  veo si esta logueado
                    if(this.isAuthenticated){
                        this.$router.push(`/doctor/${data.data.medicCoupon.medic.id}-${data.data.medicCoupon.medic.slug}?coupon=${data.data.medicCoupon.code}`);
                    }else{
                        // abro login
                        this.$router.push(`/login`);
                    }
                }else{
                    this.error = true
                }
            })
            .catch(error => {
                console.log('error al buscar.',error);
            });
        },
    },
    
};
</script>

<style scoped>
.input{
    text-transform: uppercase;
}
.error-label{
    font-size: 12px;
    margin: 2px 8px;
    color: #e21313;
}
</style>
